import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { LOGIN } from "@/constants/testIds";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/dashboard");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain min-h-screen bg-ink grid-lines grid place-items-center px-6">
      <form onSubmit={submit} className="rise w-full max-w-md rounded-3xl border border-slate-800 bg-slate-900/80 backdrop-blur-xl p-10">
        <Brand />
        <h1 className="font-display text-3xl font-bold tracking-tight mt-10">Welcome back</h1>
        <p className="text-slate-400 mt-2 text-sm">Sign in to manage your WhatsApp links and analytics.</p>
        <div className="space-y-4 mt-8">
          <Input data-testid={LOGIN.emailInput} type="email" required placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} className="h-12 bg-slate-950 border-slate-800 focus-visible:ring-emerald-500" />
          <Input data-testid={LOGIN.passwordInput} type="password" required placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)} className="h-12 bg-slate-950 border-slate-800 focus-visible:ring-emerald-500" />
        </div>
        {error && <p data-testid="login-error" className="text-red-400 text-sm mt-4">{error}</p>}
        <button data-testid={LOGIN.submitButton} disabled={busy}
          className="w-full mt-8 h-12 rounded-full bg-emerald-500 text-slate-950 font-semibold hover:bg-emerald-400 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
